import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import Footer from "./Footer";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import Header from "./Header";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <Header />
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, 1, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  return (
    <div className="product-detail">
      <Header />

      <div className="product-detail__container">
        <div className="gallery-column">
          <div className="thumbs">
            {product.images.map((img, idx) => (
              <button
                key={idx}
                className={`thumb ${idx === selectedImage ? "active" : ""}`}
                onClick={() => setImage(idx)}
                aria-label={`Show image ${idx + 1}`}
              >
                <img src={img} alt={`${product.name} thumbnail ${idx + 1}`} />
              </button>
            ))}
          </div>

          <div className="main-image">
            <img src={product.images[selectedImage]} alt={product.name} />
          </div>
        </div>

        <aside className="product-info">
          <div className="product-meta">
            <div className="product-brand">{product.brand || "Brand"}</div>
            <h1 className="product-name">{product.name}</h1>
            <div className="product-price">
              HK${Number(product.price).toLocaleString("en-US")}
            </div>
          </div>

          <div className="product-options">
            <div className="sizes">
              <div className="label">Color :</div>
              <select
                value={selectedColor}
                onChange={(e) => setSelectedColor(e.target.value)}
                aria-label="Choose your size"
              >
                {product.colors.map((s, idx) => (
                  <option key={idx} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            </div>

            <div className="sizes">
              <div className="label">Size :</div>
              <select
                value={selectedSize}
                onChange={(e) => setSelectedSize(e.target.value)}
                aria-label="Choose your size"
              >
                {product.size.map((s, idx) => (
                  <option key={idx} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="product-actions">
            <button className="add-to-cart" onClick={handleAddToCart}>
              Add to cart
            </button>
          </div>

          <div className="product-description">
            {product.description.map((p, idx) => (
              <p key={idx}>{p}</p>
            ))}
          </div>

          <div className="details-care">
            <div className="details">
              <h4>DETAILS AND CARE</h4>
              <ul>
                {product.Features.map((f, index) => (
                  <li key={index}>{f}</li>
                ))}
              </ul>
            </div>

            <div className="delivery-returns">
              <h4>DELIVERY AND RETURNS</h4>
              <p>
                Express to home — Delivery from Wednesday, January 28 | HK$100
              </p>
              <p>Free delivery when you spend HK$2,500 or more.</p>
            </div>
          </div>
        </aside>
      </div>

      <Footer />
    </div>
  );
};

export default ProductDetail;
